export default __webpack_public_path__ + "static/media/use_action_back1.a4271ce3.png";